<template>
  <div class="flex flex-col bg-white rounded-sm text-gray mx-2 my-3 p-2">
    <div class="border-b border-gray-200 mb-4">
      <nav class="flex flex-wrap gap-x-6 gap-y-0 px-4" aria-label="Tabs">
        <div :class="[currentRoute === 'registration' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('registration')">
          Registration Service
        </div>
        <div :class="[currentRoute === 'incorporation' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('incorporation')">Incorporation Service
        </div>
        <div :class="[currentRoute === 'reservation' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('reservation')">
          Reservation Service
        </div>
        <div :class="[currentRoute === 'legal-documents' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('legal-documents')">Legal Documents Service
        </div>
        <div :class="[currentRoute === 'annual-returns' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('annual-returns')">Annual Returns
        </div>
        <div :class="[currentRoute === 'form-compliance' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('form-compliance')">Forms Compliance
        </div>
        <div :class="[currentRoute === 'data-correction' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('data-correction')">Data Correction
        </div>
        <div :class="[currentRoute === 'building-societies' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('building-societies')">Building Societies
        </div>
        <div :class="[currentRoute === 'insolvency' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('insolvency')">Insolvency
        </div>
        <div :class="[currentRoute === 'record-search' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
             @click="select('record-search')">Search Certifications
        </div>
        <div
          v-if="canViewMenuItem('can_resend_search_report')"
          :class="[currentRoute === 'search-reports' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
          @click="select('search-reports')"
        >
          Search Reports
        </div>
        <div
          v-if="canViewMenuItem('can_effect_business_name')"
          :class="[currentRoute === 'business-name-effect' ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']"
          @click="select('business-name-effect')"
        >
          Business Name Effect
        </div>
      </nav>
    </div>
    <div>
      <RegistrationService v-if="currentRoute === 'registration'" />
      <IncorporationService v-if="currentRoute === 'incorporation'" />
      <ReservationService v-if="currentRoute === 'reservation'" />
      <LegalDocumentService v-if="currentRoute === 'legal-documents'" />
      <AnnualReturnsService v-if="currentRoute === 'annual-returns'" />
      <FormComplianceManager v-if="currentRoute === 'form-compliance'" />
      <DataCorrectionService v-if="currentRoute === 'data-correction'" />
      <BuildingSocietiesService v-if="currentRoute === 'building-societies'" />
      <InsolvencyService v-if="currentRoute === 'insolvency'" />
      <RecordSearchService v-if="currentRoute === 'record-search'" />
      <SearchReportsService
        v-if="currentRoute === 'search-reports' && canViewMenuItem('can_resend_search_report')"
      />
      <BusinessNameEffectService
        v-if="currentRoute === 'business-name-effect' && canViewMenuItem('can_effect_business_name')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { useAbility } from "@casl/vue";
import RegistrationService from "./views/RegistrationService.vue";
import IncorporationService from "./views/IncorporationService.vue";
import ReservationService from "./views/ReservationService.vue";
import LegalDocumentService from "./views/LegalDocumentService.vue";
import AnnualReturnsService from "./views/AnnualReturnsService.vue";
import FormComplianceManager from "./views/FormComplianceManager.vue";
import DataCorrectionService from "./views/DataCorrectionService.vue";
import BuildingSocietiesService from "./views/BuildingSocietiesService.vue";
import InsolvencyService from "./views/InsolvencyService.vue";
import RecordSearchService from "./views/RecordSearchService.vue";
import SearchReportsService from "./views/SearchReportsService.vue";
import BusinessNameEffectService from "./views/BusinessNameEffectService.vue";

const { can } = useAbility();
const canViewMenuItem = (permission: string) => can(permission, "general") === true;

const currentRoute = ref("registration");
const select = (route: string) => {
  if (route === "search-reports" && !canViewMenuItem("can_resend_search_report")) {
    return;
  }
  if (route === "business-name-effect" && !canViewMenuItem("can_effect_business_name")) {
    return;
  }
  currentRoute.value = route;
};
</script>
